/*
import covid from "../../assets/categories/coronavirus.png"
*/
/*
import rapidi from "../../assets/categories/pcr-test.png";
*/
import * as MuiIcons from "@mui/icons-material";
import {useContext, useEffect} from "react";
import {AppContext, CategoriesContext} from "../../App";
import {CATEGORIES_GET} from "../../services/utils/ApiUrls";
import axios from "axios";

export const categoriesV2 = {
    12: {
        label: "Informazioni generali", gruppo: "VACCINI",
        icon: "InfoTwoTone",
        color: "rgb(106,27,161)",
        colorTransparent: "rgba(108,15,185,0.5)",
        subCategories: [
            {label: "Altro", visible: true},
        ],
        links: [
            "https://www.agenziaentrateriscossione.gov.it",
            "https://google.it",
            "https://firelabs.it"
        ],
    },
}

export const FetchCategories = () => {
    const {categoriesV3, setCategoriesV3} = useContext(CategoriesContext);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(CATEGORIES_GET);
                setCategoriesV3(response.data);
            } catch (error) {
                console.error("Errore nel recupero delle categorie:", error);
            }
        };

        fetchData().then(); // Chiamata della funzione async all'interno di useEffect

    }, [setCategoriesV3]);

    return null;
};


export const DynamicIcon = ({iconName, iconColor, fontSize = 80}) => {
    const appContext = useContext(AppContext);

    const IconComponent = MuiIcons[iconName] || MuiIcons.HelpOutlined; // Se l'icona non esiste, mostra un'icona di default
    return <IconComponent style={{
        fontSize: fontSize,
        color: appContext.state.theme.palette.mode === "light" ? (iconColor ? iconColor : '#00b19f') : '#4fffe9',
        marginTop: 10,
        marginBottom: 10
    }}/>;
};
